<template>
  <v-card flat v-if="selectedDestiny != null">
    <v-container
      class="pa-0"
      v-if="fetchingServices == false && errorFetchingServices == false"
    >
      <v-card-subtitle>
        <v-autocomplete
          id="services-anchor"
          ref="servicesAutocomplete"
          label="Buscar un servicio"
          hint="Ctrl + S"
          :search-input.sync="currentSearch"
          :items="searchResults"
          :no-data-text="
            searching == true
              ? 'Buscando...'
              : 'Sin coincidencias para mostar (>.<)'
          "
          @change="addToSelected"
          persistent-hint
          no-filter
          dense
        >
          <template slot="item" slot-scope="{ item }">
            {{ item.item.attributes.descripcion }}
          </template>
        </v-autocomplete>
      </v-card-subtitle>
      <v-card-text>
        <v-container class="pa-0">
          <v-data-table
            :headers="headers"
            :items="selectedServices"
            hide-default-footer
            disable-pagination
          >
            <template v-slot:item.precio_unitario_calculado="{ item }">
              <input
                class="restrained"
                v-model.number="item.precio_unitario_calculado"
                type="number"
                min="0"
                @input="updateEntryValues(item)"
              />$
            </template>
            <template v-slot:item.descripcion="{ item }">{{
              item.descripcion | uppercase
            }}</template>
            <template v-slot:item.precio_unitario_final="{ item }">{{
              item.precio_unitario_final | currency
            }}</template>
            <template v-slot:item.total_local="{ item }">{{
              item.total_local | currency
            }}</template>
            <template v-slot:item.cantidad="{ item }">
              <input
                class="restrained larger"
                v-model.number="item.cantidad"
                type="number"
                min="1"
                @input="updateEntryValues(item)"
              />
            </template>
            <template v-slot:item.selected_destiny="{ item }">
              <input
                class="restrained longest"
                v-model="item.selected_destiny"
                :disabled="item.unidad != 'FLE'"
                @input="updateEntryValues(item)"
              />
            </template>
            <template v-slot:item.transport_options="{ item }">
              <v-select
                v-model="item.selected_transport"
                :items="item.transport_options"
                :disabled="item.unidad != 'FLE'"
                no-data-text="No aplica para este servicio"
                class="restrained-select"
                @change="setInitialTransportValue(item)"
              />
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn fab small color="warning" @click="deleteItem(item)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
            <template v-slot:no-data
              >No hay datos para mostrar (&gt;.&lt;)</template
            >
          </v-data-table>
        </v-container>
      </v-card-text>
    </v-container>
    <v-container
      v-if="fetchingServices == true && errorFetchingServices == false"
    >
      <v-card-subtitle class="mb-0">
        Cargando catálogo de servicios...&nbsp;
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-card-subtitle>
    </v-container>
    <v-container v-if="errorFetchingServices == true">
      <v-card-subtitle class="mb-0">
        <img src="@/assets/error.svg" alt="error_img" class="error-img" />
        Ha ocurrido un error al obtener el catálogo de servicios<br /><br />
        <v-btn color="warning" class="mx-auto" @click="getServices">
          <v-icon>mdi-update</v-icon>&nbsp; Intentar de nuevo
        </v-btn>
      </v-card-subtitle>
    </v-container>
  </v-card>
</template>

<script>
import Fuse from "fuse.js";

export default {
  data() {
    return {
      searching: false,
      resultsEnabled: false,
      searchValue: "",
      currentSearch: "",
      headers: [
        {
          text: "Cantidad",
          value: "cantidad",
          class: "indigo lighten-5 rounded-l",
        },
        {
          text: "Unidad",
          value: "unidad",
          class: "indigo lighten-5",
        },
        {
          text: "Descripción",
          value: "descripcion",
          class: "indigo lighten-5",
        },
        {
          text: "Destino",
          value: "selected_destiny",
          class: "indigo lighten-5",
        },
        {
          text: "Transporte",
          value: "transport_options",
          class: "indigo lighten-5",
        },
        {
          text: "Precio unitario",
          value: "precio_unitario_calculado",
          class: "indigo lighten-5",
        },
        {
          text: "Acciones",
          value: "actions",
          class: "indigo lighten-5 rounded-r",
        },
      ],
      clientDiscounts: [],
    };
  },
  computed: {
    role() {
      return this.$store.state.services.role;
    },
    selectedDestiny() {
      return this.$store.state.destinies.selectedDestiny;
    },
    allServices() {
      return this.$store.state.services.allServices;
    },
    allDestinies() {
      return this.$store.state.services.allDestinies;
    },
    serviceFuse() {
      return this.$store.state.services.serviceFuse;
    },
    selectedServices() {
      return this.$store.state.services.selectedServices;
    },
    fetchingServices() {
      return this.$store.state.services.fetchingServices;
    },
    errorFetchingServices() {
      return this.$store.state.services.errorFetchingServices;
    },
    searchResults() {
      if (this.serviceFuse.search == null) {
        return [];
      }
      return this.serviceFuse.search(this.searchValue);
    },
  },
  methods: {
    addToSelected({ item }) {
      // Check if the item is already in the list.
      const match = this.selectedServices.filter((p) => p.id == item?.id);
      if (match.length > 0) {
        this.$refs.servicesAutocomplete.reset();
        this.$toasted.show("Este producto ya ha sido seleccionado.", {
          type: "warning",
        });
        return;
      }
      // Prevents store role status loss on page reload. This would result on discounts always being 0.
      if (this.role == null) {
        this.$store.commit(
          "setRole",
          JSON.parse(sessionStorage.getItem("user"))["rol"]
        );
      }
      this.$store.dispatch("addService", item);
      this.$store.dispatch("updateQuotationTotals");
      this.$refs.servicesAutocomplete.reset();
    },
    updateSearch(event) {
      if (this.searching == true) {
        this.currentSearch = event;
        return;
      }
      this.searching = true;
      setTimeout(() => {
        this.searchValue = this.currentSearch;
        this.searching = false;
      }, 500);
    },
    getServices() {
      this.$store.dispatch("getServices");
    },
    updateEntryValues(item) {
      this.$store.dispatch("updateService", item);
      this.$store.dispatch("updateQuotationTotals");
    },
    deleteItem(item) {
      this.$store.dispatch("deleteService", item);
      this.$store.dispatch("updateQuotationTotals");
    },
    updateServiceList() {
      this.$store.dispatch("updateServiceList");
      this.$store.commit(
        "setServiceFuse",
        new Fuse(this.allServices, {
          includeScore: true,
          keys: ["attributes.codigo", "attributes.descripcion"],
        })
      );
    },
    setInitialTransportValue(item) {
      item.cantidad = 1;
      item.precio_unitario_calculado = item.selected_transport ?? 0;
      this.$store.dispatch("updateService", item);
      this.$store.dispatch("updateQuotationTotals");
    },
  },
  watch: {
    currentSearch(newVal) {
      if (newVal == null) {
        this.currentSearch = "";
        this.updateSearch(this.currentSearch);
        return;
      }
      this.updateSearch(newVal);
    },
  },
  created() {
    this.getServices();
  },
};
</script>

<style lang="scss" scoped>
.restrained {
  max-width: 6ch;
  border: 1px solid lightgray;
  border-radius: 0.5rem;
  padding: 0.15rem;

  &.larger {
    max-width: 7ch;
  }

  &.longest {
    max-width: 10ch;
  }

  &:focus {
    outline-color: cadetblue;
  }

  &:disabled {
    background-color: lightgray;
  }
}
.restrained-select {
  max-width: 10ch;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.hint {
  font-size: x-small;
}

.results-container {
  width: 100%;
  height: 0px;
  overflow: hidden;
  transition: height 500ms ease;
}

.results-container.open {
  overflow-y: scroll;
  height: 120px;
}

.error-img {
  display: block;
  margin: 1rem auto;
  max-height: 80px;
  width: auto;
}
</style>